/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { object } from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import loadable from '@loadable/component';

import { getFeatureFlags } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getActiveABTests } from '../../../../state/ducks/App/ducks/ABTesting/ABTesting-Selectors';
import { trackEvent } from '../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

// regular wrapup
const LoadableWrapUpContentContainer = loadable(() => import(/* webpackChunkName: "WrapUpContentContainer" */ './WrapUpContentContainer'));

// personalized wrapup
const LoadablePersonalizedWrapUpQueryContainer = loadable(() => import(/* webpackChunkName: "PersonalizedWrapUpQueryContainer" */ './PersonalizedWrapUpComponents/PersonalizedWrapUpQueryContainer'));

const WrapUpABContainer = ({ page }) => {
    const featureFlags = useSelector(getFeatureFlags);
    const personalizedWrapUpLD = featureFlags['is-pz-bought-together-wrapups-enabled'] || false;

    const activeABTests = useSelector(getActiveABTests);
    const personalizedWrapUpOptimize = activeABTests?.personalizedWrapup;

    const dispatch = useDispatch();
    useEffect(() => {
        if (personalizedWrapUpOptimize === 'variant') {
            dispatch(trackEvent({
                eventCategory: 'Personalized wrapup',
                eventAction: 'Impression',
                eventLabel: 'Variant',
            }));
        } else if (personalizedWrapUpOptimize === 'control') {
            dispatch(trackEvent({
                eventCategory: 'Personalized wrapup',
                eventAction: 'Impression',
                eventLabel: 'Control',
            }));
        }
    }, [personalizedWrapUpOptimize]);

    if (personalizedWrapUpOptimize === 'variant' || personalizedWrapUpLD) {
        return (
            <LoadablePersonalizedWrapUpQueryContainer page={page} />
        );
    }

    // regular wrapup flow
    return (
        <LoadableWrapUpContentContainer
            page={page}
        />
    );
};

WrapUpABContainer.propTypes = {
    page: object.isRequired,
};

export default WrapUpABContainer;
